module.exports = __webpack_public_path__ + "static/img/nav_bg.d359b60c.png";